import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BaseModel } from './base-model.model';

export class FaixaCarteiraPessoaJuridica extends BaseModel {
  public idAgenteFinanceiro: number;
  public idTranche: number;
  public dataInicioValidade: Date;
  public dataFimValidade: Date;
  public valorFaixa: ValorFaixaCarteiraPessoaJuridica;

  // apenas para exibicao
  public agenteExcluidoDistribuicaoLimite: boolean;
  public cnpjAgenteFinanceiro: string;
  public nomeAgenteFinanceiro: string;

  public razaoSocial: string;
	public pesoConglomerado: number;
	public codigoConglomerado: string;
	public usuarioConglomerado: string;
	public dataConglomerado: Date;
  public nomeUsuarioFaixa: string;
  public dataAtualizacaoFaixa: Date;
}

export class ValorFaixaCarteiraPessoaJuridica {
  public numeroFaixa: string;
  public labelFaixa: string;
}
